import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=70f60761&scoped=true&"
import script from "./activity.js?vue&type=script&lang=js&"
export * from "./activity.js?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=70f60761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f60761",
  null
  
)

export default component.exports